<!--
  The window a Soon item in the sidebar opens: what the feature will do, in
  three points. Nothing is promised about a date. The click that opened it was
  already counted as demand (useSidebarState#openComingSoon).
-->
<template>
  <BaseModal
    :name="COMING_SOON_MODAL_NAME"
    width-class="max-w-md"
    is-background-blurred
  >
    <div v-if="feature" class="overflow-hidden rounded-2xl">
      <div class="gm-cs-preview" aria-hidden="true">
        <div class="gm-cs-sheet">
          <span class="gm-cs-line w-2/5" />
          <span class="gm-cs-line w-4/5 opacity-60" />
          <span class="gm-cs-row">
            <i />
            <i />
            <i />
          </span>
        </div>
      </div>

      <div class="relative grid gap-3.5 px-6 pt-5 pb-6">
        <button
          type="button"
          class="absolute top-4 right-4 grid size-8 place-items-center rounded-full text-neutral-500 hover:bg-neutral-50 hover:text-neutral-900 focus-visible:ring focus-visible:ring-neutral-200 focus-visible:outline-none"
          aria-label="Close"
          @click="closeModal(COMING_SOON_MODAL_NAME)"
        >
          <XIcon class="size-4.5" />
        </button>

        <span
          class="text-secondary-700 bg-secondary-50 inline-flex items-center gap-1.5 justify-self-start rounded-full px-2.5 py-0.5 text-xs font-semibold"
        >
          <ClockIcon class="size-3.5" aria-hidden="true" />
          Coming soon
        </span>
        <h2 class="text-2xl font-bold tracking-tight text-neutral-900">
          {{ feature.title }}
        </h2>
        <p class="text-[15px] text-neutral-600">{{ feature.text }}</p>
        <ul class="grid gap-2">
          <li
            v-for="point in feature.points"
            :key="point"
            class="flex gap-2.5 text-sm text-neutral-700"
          >
            <CircleCheckIcon
              class="text-success-500 mt-0.5 size-4 shrink-0"
              aria-hidden="true"
            />
            {{ point }}
          </li>
        </ul>
        <div class="mt-1 flex flex-wrap justify-end gap-2">
          <BaseButton
            size="small"
            color="outline-secondary"
            href="/feedback"
            is-inertia-link
            @click="closeModal(COMING_SOON_MODAL_NAME)"
          >
            Share feedback
          </BaseButton>
          <BaseButton size="small" @click="closeModal(COMING_SOON_MODAL_NAME)">
            Got it
          </BaseButton>
        </div>
      </div>
    </div>
  </BaseModal>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import XIcon from '~icons/lucide/x'
import ClockIcon from '~icons/lucide/clock'
import CircleCheckIcon from '~icons/lucide/circle-check'
import BaseModal from '@/shared/components/BaseModal.vue'
import BaseButton from '@/shared/components/BaseButton.vue'
import { useModals } from '@/shared/composables/useModals.js'
import { COMING_SOON } from './comingSoon'
import { COMING_SOON_MODAL_NAME, useSidebarState } from './useSidebarState'

const { closeModal } = useModals()
const { comingSoonKey } = useSidebarState()

const feature = computed(() =>
  comingSoonKey.value ? COMING_SOON[comingSoonKey.value] : null,
)
</script>

<style scoped>
.gm-cs-preview {
  height: 8.5rem;
  padding: 1.25rem 1.5rem 0;
  display: flex;
  align-items: flex-end;
  background: linear-gradient(
    160deg,
    var(--color-secondary-50),
    var(--color-primary-50)
  );
}
.gm-cs-sheet {
  width: 100%;
  height: 100%;
  display: grid;
  align-content: start;
  gap: 0.5rem;
  padding: 0.875rem 1rem;
  border-radius: 0.75rem 0.75rem 0 0;
  background: #fff;
  box-shadow: 0 10px 30px -10px rgb(20 31 47 / 0.25);
}
.gm-cs-line {
  display: block;
  height: 0.5625rem;
  border-radius: 999px;
  background: var(--color-neutral-100);
}
.gm-cs-row {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.5rem;
  margin-top: 0.25rem;
}
.gm-cs-row i {
  height: 2.75rem;
  border-radius: 0.5rem;
  background: var(--color-neutral-50);
  box-shadow: inset 0 0 0 1px var(--color-neutral-100);
}
</style>
